/* tslint:disable */

/**
 */
export class GroupBusStationForm {
    id?: number;
    name?: string;
    ticket_price_id?: number;
    bus_stations?: number[];
    direction?: number;
    parent_gr_bus_station_id?: number;
    type?: string;
    color?: string;
}
